// extracted by mini-css-extract-plugin
module.exports = {"error":"style-module__error___3yoAk"};